<form (ngSubmit)="save()" [formGroup]="currencyForm">
	<div [alarisLoading]="currenciesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ currency.id ? ('currencies.edit' | translate) : ('currencies.add' | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-input formControlName="name" [errors]="errors">
				{{ 'currencies.name' | translate }}
			</alaris-input>

			<alaris-input formControlName="charCode" [errors]="errors">
				{{ 'currencies.char_code' | translate }}
			</alaris-input>

			<alaris-input formControlName="currencySymbol" [errors]="errors">
				{{ 'currencies.symbol' | translate }}
			</alaris-input>

			<alaris-select2 [alarisLoading]="currenciesService.loading$" [backdrop]="false" [expandable]="true"
				[label]="'currencies.icon' | translate" formControlName="currencyIconName" mode="string">
				<alaris-options2 *alarisVirtualFor="let flag of flagIcons; let index" [value]="flag"
					[virtualIndex]="index">
					@if (flag !== '') {
					<app-ds-icon [name]="flag"></app-ds-icon>
					} @else {
					@if (flag === '') {
					<span>
						{{ 'gl.none' | translate }}
					</span>
					}
					}
				</alaris-options2>
			</alaris-select2>

			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'gl.reset' | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="currencyForm.invalid || !currencyForm.dirty" alaris-button bType="primary" size="lg"
				type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>